import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import EmptyPastJobs from './EmptyPastJobs';
import Jobs from './Jobs';

import Subheader from '../common/Subheader';

const StyledSubheader = styled(Subheader)`
  margin-bottom: ${props => props.theme.spacing[2]};
`;

const StyledPastJobs = styled.div`
  margin-bottom: ${props => props.theme.spacing[3]};
`;

const PastJobs = ({
  jobs,
  onJobCardClick,
  onTransferJobClick,
  navigateExternal,
}) => (
  <>
    { jobs.length ?
      <>
        <StyledSubheader>Past Jobs</StyledSubheader>
        <StyledPastJobs>
          <Jobs
            jobs={jobs}
            onJobCardClick={onJobCardClick}
            onTransferJobClick={onTransferJobClick}
          />
        </StyledPastJobs>
      </>
      : <EmptyPastJobs navigateExternal={navigateExternal} />
    }
  </>
);

PastJobs.propTypes = {
  jobs: PropTypes.arrayOf(PropTypes.object),
  onJobCardClick: PropTypes.func.isRequired,
  onTransferJobClick: PropTypes.func.isRequired,
  navigateExternal: PropTypes.func,
};

PastJobs.defaultProps = {
  jobs: [],
  navigateExternal: () => {},
};

export default PastJobs;
